module.exports = "https://static.wmbcdn.com/uniweb/images/b69073f3efcf9cb565a6e58a18f13474.svg";